import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { constants } from 'src/app/shared/common/contants';
import { ErrorMessages } from 'src/app/shared/common/errormessages';
import { LifecycleService } from 'src/app/shared/services/lifecycle.service';
import { LocalStorageSettingsService } from 'src/app/shared/services/local-storage-settings.service';
import { LoginService } from 'src/app/shared/services/login.service';
export interface workflowData {
  workflowId: any;
}
@Component({
    selector: 'app-placeholder-workflow-step',
    templateUrl: './placeholder-workflow-step.component.html',
    styleUrls: ['./placeholder-workflow-step.component.scss'],
    standalone: false
})
export class PlaceholderWorkflowStepComponent implements OnInit {
validations_form: UntypedFormGroup;
  backgroundColorButton: string;
  backgroundColorScreen: string;
  buttonColor: string;
 workflowdId
  username: string;
   constructor(
    @Inject(MAT_DIALOG_DATA) public data: workflowData,
    private dialogRef: MatDialogRef<PlaceholderWorkflowStepComponent>,private spinner: NgxUiLoaderService, private snackbar: MatSnackBar, private constants: constants, private msg: ErrorMessages, private fb: UntypedFormBuilder,
    private localStorageSettings: LocalStorageSettingsService,private service:LifecycleService,private loginService: LoginService,
  ) {
     this.validations_form = this.fb.group({
      stepname: ['', [Validators.required]]
     
    });
  }
/**
   * @Author Shyam
   * @Date 26/03/2026
   *  @Description: Placeholder workflow steps Component
   */
  ngOnInit(): void {
     
    //  this.formValidation()
    this.workflowdId=this.data.workflowId
    console.log(this.workflowdId)
     this.username =this.localStorageSettings.getSettings("AuthUser")
   
      console.log(this.localStorageSettings.getSettings("UserId"))
      console.log(this.localStorageSettings.getSettings("AuthUsername"))
     
      
     this.backgroundColorButton = this.localStorageSettings.getSettings("ColorA");
     this.backgroundColorScreen = this.localStorageSettings.getSettings("ColorD");
    this.buttonColor = this.localStorageSettings.getSettings("ColorA");
   
    //  if (this.username) {
    // this.validations_form.get('username')?.setValue(this.username);
    // }
  }
  
  formValidation() {
    this.validations_form = new UntypedFormGroup({
      stepname: new UntypedFormControl('', [Validators.required]),
      
    })
  }

  
  cancel(){
    this.dialogRef.close()
  }
  save(){
     if (this.validations_form.invalid) {
        // mark all fields touched so mat-error shows
        Object.values(this.validations_form.controls).forEach(control => {
          control.markAsTouched();
        });

       this.snackbar.open("All mandatory fields are required", "OK", {
        duration: 5000
       });
        return; 
      }
     const payload = {
      stepid: 0,
      workflowid: this.workflowdId,
      stepname: this.validations_form.value.stepname,
      description: this.validations_form.value.description,
      steptype: 'PLACEHOLDER',
      nextsteps: '',
      taskStep: {},
    };
    console.log(payload)
    
    this.spinner.start()
    this.service.createPlaceholderWorkflowStep(payload).subscribe(res=>{
    console.log(res)
    if(res.error===true){
      this.snackbar.open(res.statusMessage, "OK", { duration: 5000 });
      this.spinner.stop();
    }else{
      this.spinner.stop();
       this.dialogRef.close({ data: res })
    }
  })
  }

 
}
